import { Box, ContentLayoutF, Heading } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import { AccountsCard } from './components/accounts-card/AccountsCard';
import { ArticlesCard } from './components/articles-card/ArticlesCard';
import { TaxSavingsCard } from './components/tax-savings-card/TaxSavingsCard';

import { ApplicationLayout } from '../../Shared/layout/ApplicationLayout';

export const UserPerformancePage: React.FC = () => {
  return (
    <ErrorBoundary fallbackType="full" feature="performance_page" owner="user_engagement">
      <ApplicationLayout pageTitle="Performance" feature="performance_page">
        <ApplicationLayout.Header>
          <Box css={{ paddingY: 'space.300' }}>
            <Heading variant="title400">Performance</Heading>
          </Box>
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <ContentLayoutF>
            <ContentLayoutF.SlotContainer css={{ paddingTop: 'space.400' }}>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <div>Chart</div>
                <AccountsCard />
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <TaxSavingsCard />
                <div>Account benefits</div>
                <ArticlesCard />
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        </ApplicationLayout.Content>
      </ApplicationLayout>
    </ErrorBoundary>
  );
};
